import { render, staticRenderFns } from "./InventoryComponent.vue?vue&type=template&id=c341fc54&scoped=true&"
import script from "./InventoryComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./InventoryComponent.vue?vue&type=style&index=0&id=c341fc54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c341fc54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
